<template>
    <page-main>
        <div class="container">
            <div class="page-border">
                <query v-model="query" syear semester keyword="社團名稱、教師編號、教師姓名">
                </query>
                <btn-group :load="reload" :insert="insert" :del="del" :deleteItems="deleteItem.length" :input="input"></btn-group>
            </div>
            <div class="page-border">
                <table class="table">
                    <thead>
                        <tr>
                            <th style="width:30px;"></th>
                            <th>學年度-學期</th>
                            <th>社團名稱</th>
                            <th>指導老師</th>
                        </tr>
                    </thead>
                    <tr v-for="item in tableData.value" :key="item.CommunityTeacherID">
                        <td data-th="選擇"><input type="checkbox" v-model="deleteItem" :value="item.CommunityTeacherID" /></td>
                        <td data-th="學年度-學期">{{item.SYear}}-{{item.Semester|semester}}</td>
                        <td data-th="社團名稱"><b-button size="sm" variant="link" @click="edit(item.CommunityTeacherID)">{{item.Name}}</b-button></td>
                        <td data-th="指導老師">{{item.Teacher|teacher}}{{item.TeacherName}}</td>
                    </tr>
                </table>
                <pagination v-model="pager" :rows="tableData.count" :rowperpage="10" @paging="load"></pagination>
            </div>
        </div>
        <Detail id="info" :modalkey="modalkey" @reload="reload" @edit="edit">
        </Detail>
        <inputmodal id="input" sample="/template/communityteacher.xlsx" url="/api/communityteacher/excel" @ok="reload()"></inputmodal>
    </page-main>
</template>

<script>
    import Detail from './communityteacherDetail.vue';
    import { master } from '@/views';
    export default master({
        name: 'communityteacher',
        api: '/api/communityteacher/',
        components: { Detail },
        filters: {
            teacher: function (value) { return value ? value + "-" : ""; }
        }
    });
</script>

<style>
</style>